// @flow

import Config from "../constants/Config";

const ewayScriptSrc = `https://secure.ewaypayments.com/scripts/eWAY.min.js`;

const LoadEwaySDK = (reinit: boolean) => {
    return new Promise((resolve, reject) => {
        if (window.eWAY) {
            if (reinit) {
                // clear old script and window object
                const oldEwayScript = document.querySelector(
                    `[src="${ewayScriptSrc}"]`
                );

                if (oldEwayScript) {
                    oldEwayScript.remove();
                }
                window.eWAY = null;

                return LoadEwaySDK().then(() => {
                    resolve();
                });
            } else {
                resolve();
            }
        } else {
            // timeout reject
            const requestTimeout = setTimeout(() => {
                clearInterval(loadCheckInterval);
                reject("LoadEwaySDK timed out.");
            }, Config.fetchTimeout);

            // loaded check resolve
            const loadCheckInterval = setInterval(() => {
                if (window.eWAY) {
                    clearTimeout(requestTimeout);
                    clearInterval(loadCheckInterval);
                    resolve();
                }
            }, 50);

            // async script include
            const ewayJs = document.createElement("script");
            ewayJs.type = "text/javascript";
            ewayJs.src = ewayScriptSrc;
            if (document && document.body) document.body.appendChild(ewayJs);
        }
    });
};

export default LoadEwaySDK;
